<template>
  <div>
    <index-header></index-header>
    <div class="_wrapper">
      <div class="_img_box" v-if="studentType===1">
        <a :href="config.web.handleBookKinder" target="_blank">
          <a-icon type="file-text" />
          下载操作文档
        </a>
        <img :src="config.web.leadingPicKinder" alt="帮助文档" />
      </div>
      <div class="_img_box" v-else>
        <a :href="config.web.handleBookSchool" target="_blank">
          <a-icon type="file-text" />
          下载操作文档
        </a>
        <img :src="config.web.leadingPicSchool" alt="帮助文档" />
      </div>
    </div>
  </div>
</template>

<script>
  import IndexCommon from './mixins/index_common';
  import IndexHeader from './components/IndexHeader';
  import config from '../../../config';

  export default {
    mixins: [IndexCommon],
    components: { IndexHeader },
    data() {
      return {
        config:config
      };
    },
    created() {
    },
    methods: {}
  };
</script>

<style lang="stylus" scoped>
  ._img_box {
    width 800px
    margin 0 auto
    padding 30px 0 0
    a {
      color #079c9c
      display inline-block
      padding 0 0 20px
      font-size 16px
      &:hover {
        text-decoration underline
      }
    }
    img {
      display block
      width 100%
    }
  }
</style>
